// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3x3LS","label":"SetPasswdForm_label__NTtnq"};